export default __webpack_public_path__ + "static/media/logo_leo_express.5b9a2d06.svg";